import { GenericStatusLabel } from '../../../shared/components/GenericStatusLabel/GenericStatusLabel';
import { GenericStatusColorType } from '../../../shared/interfaces/generic-status';

export interface PipelineReviewSectionTitleProps {
  title: string;
  hasDiff: boolean;
}

export function PipelineReviewSectionTitle({ hasDiff, title }: PipelineReviewSectionTitleProps) {
  return (
    <div className='center-flex-row'>
      <span className='text-medium'>{title}</span>

      {hasDiff ? (
        <GenericStatusLabel
          status={{
            displayName: 'Updated',
            value: 'UPDATED',
            colorType: GenericStatusColorType.INFO
          }}
          className='ml-2'
          withIcon={false}
        />
      ) : null}
    </div>
  );
}
